export default __webpack_public_path__ + "static/3-de2eb20e79e0fd48a92bebe5f0832410.jpg";